import { parse } from 'tldts';
import _upperFirst from 'lodash/upperFirst';

const VALID_HOSTS = new Set(['localhost']);

type ParsedURL = {
  domain: string;
  title: string;
  isValid: boolean;
};

const parsedURLCache = new Map<string, ParsedURL>();

export function getParsedURL(url = ''): ParsedURL {
  if (parsedURLCache.has(url)) {
    return parsedURLCache.get(url)!;
  }

  const parsed = parse(url);

  const hostname = (parsed.hostname || '').replace('www.', '') || url;
  const domain = parsed.domain || hostname;
  const title = _upperFirst(parsed.domainWithoutSuffix || domain);
  const isValidHost = VALID_HOSTS.has(hostname);
  const isValid = Boolean(parsed.isIcann || parsed.isIp || isValidHost);

  const result = {
    domain,
    title,
    isValid,
  };

  parsedURLCache.set(url, result).get(url);

  return result;
}

export default getParsedURL;
